import './ReportAccessError.scss';

// Shown when a report run failed in a way that running it again cannot fix. A lapsed session (401)
// and lost access to a team (403) are the cases this copy is written for — but canRetryAfter also
// sends anything it cannot classify here, including a response that was not a report at all and any
// error thrown inside the batch loop. That is wider than the message implies and is worth narrowing;
// PA-3289 chose that routing deliberately (see canRetryAfter in useBatchedReport).
//
// A cancellation, a network blip and a 5xx do reach ReportNotLoaded instead, where the Report
// Settings panel's Run button is the way forward.
//
// This is why that case does not just fall through to ReportNotLoaded: a signed-out user would be
// told to press Run, and pressing it would fail again with nothing new on screen.
//
// An alert rather than a status: nobody asked for this outcome, so it interrupts.
//
// The raw failure text is deliberately not rendered. It carries things like "Request failed with
// status code 401" — nothing a user can act on, and technical detail belongs in developer logs.
const ReportAccessError = () => (
  <div className="ReportAccessError" role="alert">
    <p className="ReportAccessError_Message">Oh no! Something went wrong.</p>

    <p className="ReportAccessError_Detail">
      You may need to sign in again. Refresh the page, and contact your administrator if this keeps
      happening.
    </p>
  </div>
);

export default ReportAccessError;
